<template>
  <div>
    <div class="banner">
    	<img class="banner-img" src="/static/images/Org/banner.jpg">
    	<div class="logo"><img class="logo-img" src="/static/images/Org/logo.png" /></div>
    </div>
    <div class="box">
    	<div class="box-main">
    		<div class="head-nav">
    			<a v-for="(item,index) in headNav" :class="{'head-nav-active':index == navix}" @click="NavToggle(index)">{{item}}<i></i></a>
    		</div>
    		<div class="main">
    			<div class="main-box" v-for="(val,ix) in intr" :data-url="val.url" v-if="ix == navix">
    				<div v-for="v in val.list">
              <p class="title" v-if="v.key" v-text="v.key"></p>
              <p class="text" v-if="v.value" v-text="v.value"></p>
            </div>

    			</div>
    		</div>
    		<div @click="ViewNow" class="main-button">立即查看</div>
    	</div>
    </div>
    <div class="subscript">
      <div class="subscript-main">
        <i class="subscript-icon subscript-left"></i>
        {{sign}}
        <i class="subscript-icon subscript-right"></i>
      </div>
      <div class="version" v-text="'Version'+version"></div>
    </div>
  </div>
</template>

<script>
var self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'qr',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data () {
    return {
      navix:0,
      version:null,
      headNav:["产品溯源码","国家OID公示"],
      intr:[{
      	list:[
          {key:null,value:"由：寿宁硒锌农产品大数据中心 发布"},
          {key:"*查询及公告",value:null},
          {key:null,value:"该产品原产地、生产加工、质量检测、实时库存、物流信息等相关产品信息参考"},
          {key:"*温馨提示",value:null},
          {key:null,value:"产品防伪、窜货、促销、积分、仓储等具体适用场景以当地主管部门及企业规定为准"},
      	]
      },{
      	list:[
          {key:null,value:"由：国家OID注册中心 提供"},
          {key:"*查询及公告",value:null},
          {key:null,value:"企业OID号信息公布、国家平台码查询等"},
          {key:"*温馨提示",value:null},
          {key:null,value:"208个国家及地区互联互通的通行证码，企业根据自行需求进行解析、分配，具体适用场景以企业规定为依据"},
      	]
      }],
      url:null,
      sign:"国家OID城市服务平台提供",
      datas:null
    }
  },
  mounted () {
    self = this;
    self.datas = JSON.parse(localStorage.getItem("wwm_origin"));
    self.business = JSON.parse(localStorage.getItem("wwm_business"));
    self.version = localStorage.getItem("wwm_Version");
    console.log(self.business)
    if(self.datas.origin){
      var origin = JSON.parse(self.datas.origin);

      if(self.business.company_idcode){
        self.url = origin.template.url + self.business.company_idcode + '.';
      }else{
        self.url = "http://www.oid.plus/"
      }

      self.intr[0].list = origin.template.datas;
      if(origin.template.title){
        self.headNav[0] = origin.template.title;
      }
      if(origin.template.sign){
        self.sign = origin.template.sign;
      }
    }
  },
  methods: {
    NavToggle (ix) {
    	self.navix = ix;
    },
    ViewNow () {
      if(self.navix == 0){
        let tname = localStorage.getItem("wwm_template_name");
        self.$router.push({path: "/"+tname}); // 模板路由跳转
      }else{
        window.location.href = self.url;
      }
    }
  }
}
</script>

<style scoped>
.banner{
	position: relative;
	height: 200px;
	overflow: hidden;
}
.banner-img{
	display: block;
  width: 100%;
	height: 100%;
  object-fit: cover;
}
.logo{
	position: absolute;
	top:0;
	height: 200px;
	left:0;right: 0;
	background: rgba(0,0,0,0.2);
}
.logo-img{
	height: 75px;
	display: table;
	margin:45px auto;
}
.box{
	position: relative;
}
.box-main{
	position: relative;
	top:-60px;
  margin:0 20px;
  padding-bottom: 20px;
	border-radius: 10px 10px 0 0;
	background-color: #FFF;
	box-shadow: 0 0 5px rgba(0,0,0,0.05);
}
.head-nav{
	overflow: hidden;
	padding:20px 25px;
}
.head-nav a{
	display: block;
	float: left;
	width: calc(50% - 15px);
  font-weight: bold;
	padding: 15px 5px;
	text-align: center;
	position: relative;
	color: #FFF;
  border-radius: 5px;
  opacity: 0.6;
	background-color: #2271ea;
}
.head-nav a:last-child{
  margin-left: 10px;
}
.head-nav-active{
	opacity: 1 !important;
}
.head-nav-active i{
	position: absolute;
	width: 50px;
	height: 2px;
	left:calc(50% - 25px);
	bottom:5px;
	border-radius: 5px;
	background-color: #FFF;
}

.main{
	padding:20px 25px;
  border-top: 1px solid #E9E9E9;
}
.text{
	font-size: 15px;
	color: #868686;
	margin-top: 5px;
}
.title{
	font-size: 15px;
	margin-top: 15px;
}
.main-button{
	padding: 12px 10px;
	background-color: #2271EA;
	text-align: center;
	color: #FFF;
	margin: 0 25px;
  margin-top: 20px;
	border-radius: 5px;
}
.subscript{
  position: fixed;
  bottom:0;left:0;
  right:0;
  padding: 15px 0;
  font-size: 13px;
  background-color: #EBEFF5;
}
.subscript-main{
  display: table;
  margin: 0 auto;
  color: #888;
  position: relative;
}
.subscript-icon{
  width: 30px;
  height: 1px;
  top:8px;
  position: absolute;
  background-color: #D3D3D3;
}
.subscript-left{
  left:-38px;
}
.subscript-right{
  right:-38px;
}
.version{
  color: #888;
  font-size: 11px;
  margin-top: 5px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/public-view/Org.vue